  <!-- Animated -->
            <div class="animated fadeIn">
                <!-- <h3>Admin Panel</h3>
                <br/> -->
         
                <!--  Traffic  -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-body" style="min-height: 600px;">
                                <h4 class="box-title">Add Company </h4>
                                <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
                           <br/>
                           		<div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Company Name
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="companyName" [(ngModel)]="companyName" id="companyName" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Company ID
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="companyID" [(ngModel)]="companyID" id="companyID" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="file-multiple-input" class=" form-control-label">Company Logo</label></div>
                                    <div class="col-12 col-md-9"><input type="file" id="companyLogo" [(ngModel)]="companyLogo" name="companyLogo"  class="form-control-file" accept="image/*" ></div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Email Address
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="emailAddress" id="emailAddress" [(ngModel)]="emailAddress" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Peer Group
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="peerGroup" id="peerGroup" [(ngModel)]="peerGroup" class="form-control-sm form-control" >
                                            <option value="{{pdetails.peerId}}" *ngFor="let pdetails of peerData">{{pdetails.peerGroupName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Insurer Type
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="industryType" id="industryType" [(ngModel)]="industryType" class="form-control-sm form-control" >
                                            <option [value]="idetails" *ngFor="let idetails of industryTypeData">{{idetails}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="createCompany()" >Create</button>
                                             <button type="submit" class="btn btn-primary btn-sm" style="margin-left: 10px;" (click)="resetForm()" >Reset</button>
                                        </div>

                                    </div>

                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-12" id="errCont"></div>
                                </div>
                            </div>
                        </div>
                    </div><!-- /# column -->
                </div>
                <!--  /Traffic -->
                <div class="clearfix"></div>
               
              
               
                
                
            </div>
            <!-- .animated -->






<div class="loaderbox" *ngIf="loaderVisibility" id="loaderbox">
    <div class="load" >
        <img src="assets/images/loading.gif" alt="" >
    </div>
</div>



















